import { render, staticRenderFns } from "./DynamicText.vue?vue&type=template&id=afc19df2&"
import script from "./DynamicText.vue?vue&type=script&lang=js&"
export * from "./DynamicText.vue?vue&type=script&lang=js&"
import style0 from "./DynamicText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports